<template lang="pug">
div
	.form-group
		label
			b Categorias
		input-query(
			placeholder="Busca una categoría",
			@selected="seleccionada($event)"
			input-class="form-control"
			:realtime="true"
			url="redaccion/php/api/buscar-categorias.php"
			v-if="!readonly")
	hr(v-if="!readonly")
	button.btn.btn-sm.btn-warning.m-1(
		v-for="cat in texto.Categorias"
		:key="cat.CategoriaID"
		@click="quitar(cat.CategoriaID)"
	) {{cat.Titulo}}
</template>

<script>
import axios from 'axios'
export default {
	props: ['texto', 'readonly'],
	data () {
		return {
			nueva: '',
			listadoCategorias: []
		}
	},
	methods: {
		seleccionada (ev) {
			if (this.readonly) {
				return
			}
			const form = {
				CategoriaID: ev.datos.CategoriaID,
				NoticiaID: this.texto.NoticiaID
			}
			axios.post('redaccion/php/api/add-categoria.php', form)
				.then(res => {
					this.texto.Categorias = res.data
				})
				.catch(this.$responseError)
		},
		crear () {
			if (this.readonly) {
				return
			}
			if (this.nueva) {
				const nueva = this.nueva.toUpperCase()
				if (this.listadoCategorias.indexOf(nueva) < 0) {
					this.listadoCategorias.push(nueva)
					this.nueva = ''
				}
			}
		},
		quitar (CategoriaID) {
			if (this.readonly) {
				return
			}
			const form = {
				NoticiaID: this.texto.NoticiaID,
				CategoriaID: CategoriaID
			}
			axios.post('redaccion/php/api/del-categoria.php', form)
				.then(res => {
					this.texto.Categorias = res.data
				})
				.catch(this.$responseError)
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/editor/categorias.vue